module.exports = __webpack_public_path__ + "static/cryptoAreaChart-f1e079db6f201ca845939cd1ffd237a6.png";